goog.provide('el8.appchart.dialog.refaxLetter');

goog.require('el8.appservice.notifier');
goog.require('el8.ptdata.letters');
goog.require('el8.template.appchart.dialog.refaxLetter');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.NewDialog');


el8.appchart.dialog.refaxLetter = (function(){

    var curLetter = null;

    var that = new el8.uiwidget.NewDialog({
        title: 'Fax Letter Again',
        modal: false,
        position: 'center',
        autoHeight: true,
        width: 350
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'send-fax', 'Send Fax', function() {
            buttonSet.disable();
            var dict = {
                successCb: function() {
                    el8.appservice.notifier.notify('Your letter is being re-faxed');
                    that.hide();
                },
                errorCb: function() {
                    buttonSet.enable();
                }
            };
            var $checkbox = $(':input[name="includeAttachments"]', that.getContentElt());
            if ($checkbox.is(':visible')) { dict.faxAttachments = $checkbox.is(':checked'); }
            curLetter.refaxLetter(dict);
        }, true
    );
    buttonSet.addButton(
        'print', 'Print Preview', function() {
            window.open(el8.service.urls.get('printPdfLetter', [curLetter]));
        }, false
    );
    buttonSet.addButton(
        'cancel', 'Cancel', function() {
            that.hide();
        }, false
    );
    that.setButtonSet(buttonSet);

    // Commented out because we need to figure out what happens with deleted contacts
    // var super_init = that._init;
    // that._init = function() {
    //     super_init.call(that);

    //     that.getContentElt().on('click', '.edit-contact-trigger',  function() {
    //         var contactId = $(this).data('id');
    //         el8.app.shared.network.viewEditConnection.show({ contactId: contactId });
    //     });
    // };

    var super_show = that.show;
    that.show = function(letter) {
        curLetter = letter;
        super_show.call(that);
        that.setContent(
            el8.template.appchart.dialog.refaxLetter.content(curLetter.asSoyMap())
        );
        var contact = null;
        if (curLetter.getSendToContactId()) {
            contact = el8.data.physicians.getById(curLetter.getSendToContactId());
        }
        // can't send to passport for raw faxes or med groups
        if (!contact ||
                (contact && contact.getContactType() === el8.util.consts.MEDICAL_GROUP_TYPE) ||
                curLetter.getFinalPdfPages({ async: false }) > el8.util.consts.EL8_HI_FAX_PAGES) {

            $('.fax-attachments-section', that.getContentElt()).hide();
        } else {
            // default the checkbox to whatever the letter's value was
            $(':input[name="includeAttachments"]', that.getContentElt()).prop('checked', curLetter.isFaxAttachments());
        }
        that.adjustHeight();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        buttonSet.enable();
        curLetter = null;
    };

    return that;
})();
